import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import ErrorMsg from "../../components/form/errorMsg";
import { useNavigate } from "react-router-dom";
import back from "../../assets/back.svg";
import { useDispatch } from "react-redux";
import { supportCreate } from "../../redux/actions/supportAction";
import Topnav from "../../components/topnav/topnav";
import ErrorPopup from "../../components/Popups/ErrorPopup";
import SuccessPopup from "../../components/Popups/SuccessPopUp";

const Support = () => {
  const dispatch = useDispatch();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState('');
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState('');

  const navigate = useNavigate();
  const initialValues = {
    title: "",
    description: "",
  };
  const loginSchema = Yup.object().shape({
    title: Yup.string().trim().required("* Required"),
    description: Yup.string().trim().required("* Required"),
  });
  const onSubmit = (values, { resetForm }) => {
    console.log(values);
    dispatch(supportCreate(values, onSuccess, onError));
    resetForm();
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
    navigate('/current-orders');
  }

  const onSuccess = (data) => {
    console.log(data);
    setShowSuccessPopup(true);
    const message = (data.data.message);
    const msg_updated = message.charAt(0).toUpperCase() + message.slice();
    setShowSuccessMsg(msg_updated);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false)
  }

  const onError = (err) => {
    console.log(err);
    setShowErrorPopup(true)
    const str = (err.data.message);
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  return (
    <>
      <Topnav />
      <div >
        <div
          className="d-flex   p-2 ms-3 m-1 mb-2"
          onClick={() => navigate(-1)}
        >
          <img src={back} alt="back_btn" />
          <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
            BACK
          </span>
        </div>
        <div className="d-flex justify-content-center align-items-center fn_Nunito col-12 my-5 py-5 ">
          <div className="support-main-container col-10 col-md-8  px-4 py-4 my-auto ">
            <label className="fs_22 fs_sm_20 fw_700">Support</label>
            <label className="color_747f9e fs_12">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Iaculis
              nulla venenatis nunc odio tincidunt.
            </label>

            <Formik
              initialValues={initialValues}
              validationSchema={loginSchema}
              onSubmit={onSubmit}
            >
              {(props) => (
                <Form>
                  <div className="mt-4 pt-2">
                    <div className="">
                      <label className="fs_14 color_262c3d ">
                        Title of issue
                      </label>
                      {/* <input
              type="text"
              id="Title"
              name=""
              className="w-100  p-2"
              placeholder=""
            /> */}
                      <Field name={"title"}>
                        {({ field, meta }) => (
                          <input
                            {...field}
                            placeholder="Enter title of issue"
                            id={"title"}
                            className={"w-100 support-input  p-2"}
                          />
                        )}
                      </Field>
                      <ErrorMsg name="title" />
                    </div>
                    <div className="">
                      <label className="mt-3 fs_14 color_262c3d">Issue</label>
                      <div>
                        <Field name={"description"}>
                          {({ field, meta }) => (
                            <textarea
                              {...field}
                              id="description"
                              name="description"
                              className="support-text-area p-2 w-100"
                              placeholder="Write an issue you have"
                              rows={6}
                            ></textarea>
                          )}
                        </Field>
                        <ErrorMsg name="description" />
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="support-submit-btn w-100 text-white py-2 fs_14 fs_sm_12 mt-3"
                  >
                    submit
                  </button>
                </Form>
              )}
            </Formik>
            <ErrorPopup
              show={showErrorPopup}
              title={showErrorMsg}
              handleClose={closeErrorPopup}
            />
            <SuccessPopup
              show={showSuccessPopup}
              title={showSuccessMsg}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Support;
